import { render, staticRenderFns } from "./SupplierContactDetailsForm.vue?vue&type=template&id=3eddb127&scoped=true&"
import script from "./SupplierContactDetailsForm.vue?vue&type=script&lang=js&"
export * from "./SupplierContactDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContactDetailsForm.vue?vue&type=style&index=0&id=3eddb127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eddb127",
  null
  
)

export default component.exports